import './TermsPage.css'

function TermsPage() {
  return (
    <div className="terms-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Vilkår og betingelser</h1>
          <p>Sist oppdatert: Oktober 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Aksept av vilkår</h2>
            <p>
              Ved å bruke CommunityNord-tjenestene godtar du disse vilkårene og betingelsene. 
              Hvis du ikke godtar disse vilkårene, vennligst ikke bruk våre tjenester.
            </p>

            <h2>2. Beskrivelse av tjenesten</h2>
            <p>
              CommunityNord tilbyr en nettbasert plattform for medlemsadministrasjon, kommunikasjon, 
              arrangementer og betalinger for norske foreninger og organisasjoner. Tjenesten inkluderer 
              tilgang til web-applikasjonen.
            </p>

            <h2>3. Konto og registrering</h2>
            <p>For å bruke visse deler av tjenesten må du opprette en konto. Du er ansvarlig for:</p>
            <ul>
              <li>Å gi korrekt og fullstendig informasjon ved registrering</li>
              <li>Å holde kontoinformasjonen oppdatert</li>
              <li>Å beskytte dine påloggingsinformasjon</li>
              <li>All aktivitet som skjer via din konto</li>
            </ul>

            <h2>4. Abonnement og betaling</h2>
            <p>
              Tjenesten tilbys som et månedlig abonnement. I en innledende periode er alle planer gratis,
              selv om en månedspris står oppført. Vi varsler minst 30 dager før fakturering starter.
              Når den har startet, godtar du ved å abonnere å betale den aktuelle avgiften, og prisene kan endres med 30 dagers varsel.
            </p>
            <ul>
              <li>Når fakturering har startet, fornyes abonnementet automatisk hver måned</li>
              <li>Du kan si opp abonnementet når som helst</li>
              <li>Ingen refusjon for delvise perioder</li>
              <li>Alle priser er i norske kroner</li>
            </ul>

            <h2>5. Brukeransvar</h2>
            <p>Du samtykker i å:</p>
            <ul>
              <li>Bruke tjenesten i samsvar med gjeldende lovverk</li>
              <li>Ikke laste opp skadelig eller ulovlig innhold</li>
              <li>Ikke bryte andres rettigheter</li>
              <li>Ikke forsøke å kompromittere sikkerheten til plattformen</li>
            </ul>

            <h2>6. Immaterielle rettigheter</h2>
            <p>
              CommunityNord og alt innhold, funksjoner og funksjonalitet er eid av oss eller våre 
              lisensgivere og er beskyttet av opphavsrett, varemerke og andre lover.
            </p>
            <p>
              Du beholder alle rettigheter til innholdet du laster opp, men gir oss en lisens til å 
              lagre, vise og behandle dette innholdet for å levere tjenesten.
            </p>

            <h2>7. Data og personvern</h2>
            <p>
              Din bruk av tjenesten er også underlagt vår Personvernerklæring. Ved å bruke 
              tjenesten samtykker du til at vi behandler dine data som beskrevet der.
            </p>

            <h2>8. Begrensning av ansvar</h2>
            <p>
              CommunityNord leveres «som den er». Vi gir ingen garantier, verken uttrykkelige eller 
              underforståtte. Vi er ikke ansvarlige for indirekte, tilfeldige eller følgeskader 
              som oppstår fra din bruk av tjenesten.
            </p>
            <p>
              Vår totale ansvar er begrenset til beløpet du har betalt for tjenesten de siste 
              12 månedene.
            </p>

            <h2>9. Opphør</h2>
            <p>
              Vi kan avslutte eller suspendere din tilgang til tjenesten umiddelbart, uten 
              forvarsel, hvis du bryter disse vilkårene. Ved opphør vil din tilgang og data 
              kunne slettes i henhold til vår personvernerklæring.
            </p>

            <h2>10. Endringer av vilkår</h2>
            <p>
              Vi forbeholder oss retten til å endre disse vilkårene når som helst. Vesentlige 
              endringer vil bli varslet via e-post eller gjennom plattformen. Fortsatt bruk 
              etter endringer anses som aksept av de nye vilkårene.
            </p>

            <h2>11. Lovvalg og verneting</h2>
            <p>
              Disse vilkårene reguleres av norsk lov. Alle tvister skal løses ved norske domstoler.
            </p>

            <h2>12. Kontakt</h2>
            <p>
              For spørsmål om disse vilkårene, kontakt oss på:
            </p>
            <p>
              <strong>E-post:</strong> post@communitynord.com<br />
              <strong>Adresse:</strong> Norge
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TermsPage
